import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { Small } from 'foundations-components/transitional/components/Small';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import LinkWrapper from 'pricing-pages-ui-components/components/LinkWrapper';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { RevOsRename } from '../i18n/RevOsRename';
import { getKBCurrenciesUrl, getKBPaymentsUrl } from '../../utils/publicKbUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const STRIPE_PRICING_URL = 'https://stripe.com/pricing';
const HUBSPOT_PAYMENTS_PROMO_URL = 'https://legal.hubspot.com/commercehub-promo';
const HUBSPOT_PAYMENTS_TERMS_URL = 'https://legal.hubspot.com/payments-terms-of-use';
const HelpTooltip = ({
  title,
  headingText,
  maxWidth,
  children
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [children, ' ', /*#__PURE__*/_jsx(Tooltip, {
      headingText: headingText,
      use: "longform",
      placement: "bottom",
      title: title,
      maxInlineSize: maxWidth,
      children: /*#__PURE__*/_jsx(InfoIcon, {
        color: "icon-core-subtle"
      })
    })]
  });
};
const HubSpotValueProps = () => {
  return /*#__PURE__*/_jsxs(List, {
    paddingBlockStart: "500",
    marginBlockEnd: "0",
    children: [/*#__PURE__*/_jsxs(ListItem, {
      marginBlockStart: "200",
      marginBlockEnd: "300",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        paddingInlineEnd: "200",
        children: /*#__PURE__*/_jsx(SuccessIcon, {})
      }), /*#__PURE__*/_jsx(RevOsRename, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "commerce-hub.processorCards.hubspot.valueProps.1"
        })
      })]
    }), /*#__PURE__*/_jsxs(ListItem, {
      marginBlockEnd: "300",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        paddingInlineEnd: "200",
        children: /*#__PURE__*/_jsx(SuccessIcon, {})
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "commerce-hub.processorCards.hubspot.valueProps.2"
      })]
    }), /*#__PURE__*/_jsxs(ListItem, {
      marginBlockEnd: "300",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        paddingInlineEnd: "200",
        children: /*#__PURE__*/_jsx(SuccessIcon, {})
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "commerce-hub.processorCards.hubspot.valueProps.3"
      })]
    }), /*#__PURE__*/_jsxs(ListItem, {
      marginBlockEnd: "0",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        paddingInlineEnd: "200",
        children: /*#__PURE__*/_jsx(SuccessIcon, {})
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "commerce-hub.processorCards.hubspot.valueProps.4"
      })]
    }), /*#__PURE__*/_jsxs(ListItem, {
      marginBlockEnd: "0",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        paddingInlineEnd: "200",
        children: /*#__PURE__*/_jsx(SuccessIcon, {})
      }), /*#__PURE__*/_jsx(RevOsRename, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "commerce-hub.processorCards.hubspot.valueProps.5"
        })
      })]
    })]
  });
};
const HubspotPaymentMethods = ({
  countryCode
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "strong",
      typography: "heading-50",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "commerce-hub.processorCards.hubspot.paymentMethods.title"
      })
    }), /*#__PURE__*/_jsxs(List, {
      styled: true,
      marginBlockEnd: "0",
      children: [/*#__PURE__*/_jsx(ListItem, {
        marginBlockStart: "200",
        marginBlockEnd: "300",
        children: countryCode === 'CA' ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "commerce-hub.processorCards.hubspot.paymentMethods.cardsCA"
        }) : countryCode === 'GB' ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "commerce-hub.processorCards.hubspot.paymentMethods.cardsGB"
        }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "commerce-hub.processorCards.hubspot.paymentMethods.cards"
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        marginBlockEnd: "0",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "commerce-hub.processorCards.hubspot.paymentMethods.currencies_jsx",
          options: {
            href: getKBCurrenciesUrl(),
            external: true
          },
          elements: {
            UILink: LinkWrapper
          }
        })
      })]
    })]
  });
};
const HubSpotCardFeeTooltip = ({
  children
}) => {
  return /*#__PURE__*/_jsx(HelpTooltip, {
    headingText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "commerce-hub.processorCards.hubspot.platformFeesTooltip.heading"
    }),
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(List, {
        styled: true,
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(RevOsRename, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "commerce-hub.processorCards.hubspot.platformFeesTooltip.listItemOne"
            })
          })
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "commerce-hub.processorCards.hubspot.platformFeesTooltip.title"
      }), /*#__PURE__*/_jsx(List, {
        styled: true,
        children: /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "commerce-hub.processorCards.hubspot.platformFeesTooltip.listItemTwo_jsx",
            options: {
              href: HUBSPOT_PAYMENTS_TERMS_URL,
              external: true
            },
            elements: {
              UILink: LinkWrapper
            }
          })
        })
      })]
    }),
    children: children
  });
};
const HubspotCardFeeDetails = ({
  countryCode
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "strong",
      typography: "heading-50",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "commerce-hub.processorCards.hubspot.processingFees.title"
      })
    }), /*#__PURE__*/_jsxs(List, {
      styled: true,
      marginBlockEnd: "0",
      children: [countryCode === 'CA' ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ListItem, {
          marginBlockStart: "200",
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(HubSpotCardFeeTooltip, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "commerce-hub.processorCards.hubspot.processingFees.cardFeesCA"
            })
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(HubSpotCardFeeTooltip, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "commerce-hub.processorCards.hubspot.processingFees.achFeesCA"
            })
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(HubSpotCardFeeTooltip, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "commerce-hub.processorCards.hubspot.processingFees.padFeesCA"
            })
          })
        })]
      }) : countryCode === 'GB' ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ListItem, {
          marginBlockStart: "200",
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(HubSpotCardFeeTooltip, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "commerce-hub.processorCards.hubspot.processingFees.cardFeesGB"
            })
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(HubSpotCardFeeTooltip, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "commerce-hub.processorCards.hubspot.processingFees.bacsFeesGB"
            })
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(HubSpotCardFeeTooltip, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "commerce-hub.processorCards.hubspot.processingFees.sepaFeesGB"
            })
          })
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ListItem, {
          marginBlockStart: "200",
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(HubSpotCardFeeTooltip, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "commerce-hub.processorCards.hubspot.processingFees.cardFees"
            })
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          marginBlockEnd: "300",
          children: /*#__PURE__*/_jsx(HubSpotCardFeeTooltip, {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "commerce-hub.processorCards.hubspot.processingFees.achFees"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(ListItem, {
        marginBlockEnd: "0",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "commerce-hub.processorCards.hubspot.processingFees.highVolumeBusiness",
          options: {
            Link: /*#__PURE__*/_jsx(Link, {
              href: "mailto:commerceteam@hubspot.com",
              external: true,
              children: /*#__PURE__*/_jsx(RevOsRename, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "commerce-hub.processorCards.hubspot.processingFees.highVolumeBusinessLink"
                })
              })
            })
          }
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "300",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "commerce-hub.processorCards.hubspot.learnMoreAboutPricing_jsx",
        options: {
          href: getKBPaymentsUrl('#rates-fees'),
          external: true
        },
        elements: {
          UILink: LinkWrapper
        }
      })
    })]
  });
};
const StripeValueProps = () => {
  return /*#__PURE__*/_jsxs(List, {
    paddingBlockStart: "500",
    marginBlockEnd: "0",
    children: [/*#__PURE__*/_jsxs(ListItem, {
      marginBlockStart: "200",
      marginBlockEnd: "300",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        paddingInlineEnd: "200",
        children: /*#__PURE__*/_jsx(SuccessIcon, {})
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "commerce-hub.processorCards.stripe.valueProps.1"
      })]
    }), /*#__PURE__*/_jsxs(ListItem, {
      marginBlockEnd: "300",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        paddingInlineEnd: "200",
        children: /*#__PURE__*/_jsx(SuccessIcon, {})
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "commerce-hub.processorCards.stripe.valueProps.2_jsx",
        options: {
          href: STRIPE_PRICING_URL,
          external: true
        },
        elements: {
          UILink: LinkWrapper
        }
      })]
    }), /*#__PURE__*/_jsxs(ListItem, {
      marginBlockEnd: "0",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        paddingInlineEnd: "200",
        children: /*#__PURE__*/_jsx(SuccessIcon, {})
      }), /*#__PURE__*/_jsx(RevOsRename, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "commerce-hub.processorCards.stripe.valueProps.3_jsx",
          options: {
            href: STRIPE_PRICING_URL,
            external: true
          },
          elements: {
            UILink: LinkWrapper
          }
        })
      })]
    })]
  });
};
const StripePaymentMethods = ({
  countryCode
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "strong",
      typography: "heading-50",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "commerce-hub.processorCards.stripe.paymentMethods.title"
      })
    }), /*#__PURE__*/_jsxs(List, {
      styled: true,
      marginBlockEnd: "0",
      children: [/*#__PURE__*/_jsx(ListItem, {
        marginBlockStart: "200",
        marginBlockEnd: "300",
        children: countryCode === 'CA' ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "commerce-hub.processorCards.stripe.paymentMethods.cardsCA"
        }) : countryCode === 'GB' ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "commerce-hub.processorCards.stripe.paymentMethods.cardsGB"
        }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "commerce-hub.processorCards.stripe.paymentMethods.cards"
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        marginBlockEnd: "0",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "commerce-hub.processorCards.stripe.paymentMethods.currencies_jsx",
          options: {
            href: getKBCurrenciesUrl(),
            external: true
          },
          elements: {
            UILink: LinkWrapper
          }
        })
      })]
    })]
  });
};
const StripeCardFeeDetails = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "strong",
      typography: "heading-50",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "commerce-hub.processorCards.stripe.processingFees.title"
      })
    }), /*#__PURE__*/_jsxs(List, {
      styled: true,
      marginBlockEnd: "0",
      children: [/*#__PURE__*/_jsx(ListItem, {
        marginBlockStart: "200",
        marginBlockEnd: "300",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "commerce-hub.processorCards.stripe.processingFees.cardFees"
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        marginBlockEnd: "300",
        children: /*#__PURE__*/_jsx(HelpTooltip, {
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "commerce-hub.processorCards.stripe.platformFeesTooltip.heading"
          }),
          title: /*#__PURE__*/_jsx(List, {
            styled: true,
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(ListItem, {
              children: /*#__PURE__*/_jsx(RevOsRename, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "commerce-hub.processorCards.stripe.platformFeesTooltip.listItemOne"
                })
              })
            })
          }),
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "commerce-hub.processorCards.stripe.processingFees.platformFees"
          })
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "commerce-hub.processorCards.hubspot.learnMoreAboutPricing_jsx",
        options: {
          href: getKBPaymentsUrl('#rates-fees'),
          external: true
        },
        elements: {
          UILink: LinkWrapper
        }
      })
    })]
  });
};
export const ValueProps = ({
  processor
}) => {
  return processor === 'HS_PAYMENTS' ? /*#__PURE__*/_jsx(HubSpotValueProps, {}) : /*#__PURE__*/_jsx(StripeValueProps, {});
};
export const FeeDetails = ({
  processor,
  countryCode
}) => {
  return processor === 'HS_PAYMENTS' ? /*#__PURE__*/_jsx(HubspotCardFeeDetails, {
    countryCode: countryCode
  }) : /*#__PURE__*/_jsx(StripeCardFeeDetails, {});
};
export const PaymentMethods = ({
  processor,
  countryCode
}) => {
  return processor === 'HS_PAYMENTS' ? /*#__PURE__*/_jsx(HubspotPaymentMethods, {
    countryCode: countryCode
  }) : /*#__PURE__*/_jsx(StripePaymentMethods, {
    countryCode: countryCode
  });
};
export const ProcessorLogo = ({
  processor
}) => {
  const logoKey = processor === 'HS_PAYMENTS' ? 'hubspot-wordmark' : 'stripe-wordmark-blurple';
  return /*#__PURE__*/_jsx(TFlex, {
    direction: "column",
    justify: "center",
    align: "center",
    children: /*#__PURE__*/_jsx(Logo, {
      marginBlockEnd: "300",
      name: logoKey,
      height: 50,
      role: "heading",
      "aria-level": 3,
      alt: processor === 'HS_PAYMENTS' ? 'HubSpot' : 'Stripe'
    })
  });
};
export const PromoSection = ({
  processor
}) => {
  return /*#__PURE__*/_jsx(TFlex, {
    direction: "column",
    justify: "start",
    align: "center",
    gap: 14,
    children: processor === 'HS_PAYMENTS' && /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "commerce-hub.processorCards.hubspot.disclaimer_6_30_jsx",
        options: {
          href: HUBSPOT_PAYMENTS_PROMO_URL,
          external: true
        },
        elements: {
          LinkWrapper: props => /*#__PURE__*/_jsx(LinkWrapper, Object.assign({}, props)),
          Bold: props => /*#__PURE__*/_jsx(Text, Object.assign({
            typography: "heading-25",
            as: "span"
          }, props))
        }
      })
    })
  });
};
export const AvailableWithSection = ({
  processor,
  countryCode
}) => {
  if (processor === 'HS_PAYMENTS') {
    if (countryCode === 'CA') {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "commerce-hub.processorCards.hubspot.availableWithCA"
      });
    }
    if (countryCode === 'GB') {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "commerce-hub.processorCards.hubspot.availableWithGB"
      });
    }
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "commerce-hub.processorCards.hubspot.availableWith"
    });
  }
  if (countryCode === 'CA') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "commerce-hub.processorCards.stripe.availableWithCA"
    });
  }
  if (countryCode === 'GB') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "commerce-hub.processorCards.stripe.availableWithGB"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "commerce-hub.processorCards.stripe.availableWith"
  });
};